// import { FileRecord } from "@reactioncommerce/file-collections";
import FileRecord from "./FileRecord";
import config from "./config";

const { REACT_APP_PUBLIC_FILES_BASE_URL } = config;

FileRecord.downloadEndpointPrefix = "/assets/files";
FileRecord.uploadEndpoint = "/assets/uploads";
FileRecord.absoluteUrlPrefix = REACT_APP_PUBLIC_FILES_BASE_URL;